import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StickyNavbarDirective } from './sticky-navbar.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [StickyNavbarDirective],
  exports: [StickyNavbarDirective]
})
export class StickyNavbarModule {}
